import { render, staticRenderFns } from "./ProductListDesktopView.vue?vue&type=template&id=a5107a1c&"
import script from "./ProductListDesktopView.vue?vue&type=script&lang=js&"
export * from "./ProductListDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports